import { jsx as _jsx } from "react/jsx-runtime";
import toast from "react-hot-toast";
import { TextInput } from "../../components/Inputs";
import { useTranslations } from "../../providers/useTranslations";
export const CopyCodeButton = ({ value }) => {
    const { __ } = useTranslations();
    const handleCopy = async () => {
        if ("clipboard" in navigator) {
            try {
                await navigator.clipboard.writeText(value);
                toast.success(__("copy.code.button"));
            }
            catch (error) {
                console.error("Failed to copy text: ", error);
            }
        }
    };
    return (_jsx(TextInput, { value: value, readOnly: true, mode: "editable", onEditClick: handleCopy, editButtonLabel: __("copy.code.button.label", undefined, "Copy") }));
};
//# sourceMappingURL=CopyCodeButton.js.map